<template>
  <div>
    <b-row>
      <b-col cols="4">
        <OdontogramaDetalle :dientesSeleccionados="dientesSeleccionados"/>
      </b-col>
      <b-col style="font-size: large" class="text-left m-2">
        <div></div>
        <div class="m-4">
          <span style="font-weight: bold">Elementos enviados al laboratorio: </span><span v-for="(elemento, index) of datosOdt.elementos" :key="index">{{elemento}}<span v-if="index !== (datosOdt.elementos.length-1)">, </span> </span>
        </div>
        <div class="m-4">
          <span style="font-weight: bold">Aparatos: </span><span v-for="(aparato, index) of datosOdt.aparatos" :key="index">{{aparato}}<span v-if="index !== (datosOdt.aparatos.length-1)">, </span> </span>
        </div>
        <div class="m-4">
          <span style="font-weight: bold">Accesorios: </span><span v-for="(accesorio, index) of datosOdt.accesorios" :key="index">{{accesorio}}<span v-if="index !== (datosOdt.accesorios.length-1)">, </span> </span>
        </div>
        <div class="m-4">
          <span style="font-weight: bold">Colores: </span><span v-for="(color, index) of datosOdt.colores" :key="index">{{color}}<span v-if="index !== (datosOdt.colores.length-1)">, </span> </span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import OdontogramaDetalle from "./OdontogramaDetalle.vue";
export default {
  name: "DetalleOrtodonciaOrtopedia",
  components: {OdontogramaDetalle},
  props: {
    datosOdt: Object,
  },
  data: () => ({
    dientesSeleccionados: [],
  })
}
</script>
<style scoped>
</style>